import { useEffect, useState } from "react";

/**
 * Similar to useDebounce, but instead will immediately update state if
 * value is truthy (i.e. only debounces falsy value).
 */
export const useDebounceFalsy = <T>(value: T, falsyDelay = 350, truthyDelay = 0): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(
      () => {
        setDebouncedValue(value);
      },
      value ? truthyDelay : falsyDelay
    );

    return () => {
      clearTimeout(handler);
    };
  }, [value, falsyDelay, truthyDelay]);

  return debouncedValue;
};
